module.exports = __webpack_public_path__ + "static/media/Youtube.e1447b1a.svg";